import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

// Backend GET response → frontend camelCase shape
export const fromApi = raw => {
  const { pO_ReqNumber, pO_Date, wH_PartRefNumber, wH_ContractNumber, wH_Name, sP_Name, ...rest } = raw;

  console.log('Mapping API response to form values:', raw);

  return {
    ...rest,
    poReqNumber: pO_ReqNumber,
    poDate: pO_Date ?? toLocalISO(),
    whPartRefNumber: wH_PartRefNumber ?? '',
    whContractNumber: wH_ContractNumber ?? '',
    whName: wH_Name ?? '',
    spName: sP_Name ?? '',
  };
};

// Frontend form values → backend Add/Edit payload
export const toApi = (formValues, isEdit = false) => {
  const {
    files,
    invoiceFiles,
    poReqNumber,
    poDate,
    whPartRefNumber,
    whContractNumber,
    whName,
    spName,
    ...rest
  } = formValues;

  console.log('Mapping form values to API payload:', formValues);

  return {
    ...rest,
    poReqNumber: isEdit ? poReqNumber ?? 0 : 0,
    poDate: poDate,
    submissionDate: toLocalISO(rest.submissionDate),
    bookInDate: rest.bookInDate,
    checkoutDate: rest.checkoutDate,
    whPartRefNumber: whPartRefNumber ?? null,
    whContractNumber: whContractNumber ?? null,
    whName: whName ?? null,
    spName: spName ?? null,
    totalNetValue: rest.totalNetValue ? parseFloat(rest.totalNetValue) : null,
    recordModifiedDate: toLocalISO(),
  };
};
